import { render } from "./ChoicesBcl.vue?vue&type=template&id=09102d66"
import script from "./ChoicesBcl.vue?vue&type=script&lang=js"
export * from "./ChoicesBcl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__